import React from 'react';
import { tabStyles, cx } from '../styles';

type TabsProps = {
  tabs: string[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
};

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, setActiveTab }) => (
  <div className={tabStyles.container}>
    {tabs.map(tab => (
      <button
        key={tab}
        className={cx(
          tabStyles.tab.base,
          activeTab === tab ? tabStyles.tab.active : tabStyles.tab.inactive
        )}
        onClick={() => setActiveTab(tab)}
      >
        {/* Background glow effect for active tab */}
        {activeTab === tab && (
          <div className={tabStyles.tab.glow}></div>
        )}
        
        {/* Tab content */}
        <span className={tabStyles.tab.content}>{tab}</span>
        
        {/* Modern active indicator - bottom accent line */}
        <div className={cx(
          tabStyles.tab.indicator,
          activeTab === tab ? tabStyles.tab.indicatorActive : tabStyles.tab.indicatorInactive
        )}></div>
        
        {/* Subtle shine effect on hover */}
        <div className={tabStyles.tab.shine}></div>
      </button>
    ))}
  </div>
);

export default Tabs;
